(() => {
  const mobile = matchMedia('(max-width: 720px)');
  document.querySelectorAll('[data-entry-builder], [data-flex-builder]').forEach(root => {
    const area = root.querySelector('#entry-picks');
    const bar = root.querySelector('.entry-mobile-bar');
    if (!area || !bar || root.dataset.mobileVisibilityReady) return;
    root.dataset.mobileVisibilityReady = 'true';
    let frame = 0;
    const update = () => {
      frame = 0;
      const viewport = window.visualViewport;
      const top = viewport?.offsetTop || 0;
      const bottom = top + (viewport?.height || innerHeight);
      const bounds = area.getBoundingClientRect();
      const barHeight = bar.getBoundingClientRect().height;
      const visible = mobile.matches && bounds.top < Math.min(100, bottom - barHeight) && bounds.bottom > top;
      root.dataset.bundleAreaVisible = String(visible);
      bar.setAttribute('aria-hidden', String(!visible));
      bar.inert = !visible;
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    addEventListener('pageshow', schedule);
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
    mobile.addEventListener('change', schedule);
    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(schedule);
      observer.observe(area);
      observer.observe(bar);
    }
    update();
  });
})();
